import React, { useState, useEffect } from 'react';
import GaugeChart from 'react-gauge-chart';
import { GetColor, formatValue } from '../../utils';
import * as s from './style-gauge-chart';

const GaugeChartComponent = ({
  labelFontSize = '18px',
  onClick,
  value,
  arcsLength = [0.05, 0.2, 0.5, 0.2, 0.05],
  graphLabel = 'label',
  name = 'test-gauge',
  color,
  ranges,
  index,
  GaugeWidth,
  GaugeMinWidth,
  unit,
}) => {
  const [rangeLabelText, setRangeLabelText] = useState('');
  const [arrowPercent, setArrowPercent] = useState(0);
  function setStage() {
    let minTotal, maxTotal;
    // eslint-disable-next-line guard-for-in
    for (const i in ranges) {
      let { min, max } = ranges[i];
      min = parseFloat(min);
      max = parseFloat(max);
      if (min < minTotal || !minTotal) {
        minTotal = min;
      }
      if (max > maxTotal || !maxTotal) {
        maxTotal = max;
      }
    }
    let arrowPoint;
    if (value < minTotal) arrowPoint = 0;
    else if (value > maxTotal) arrowPoint = 1;
    else {
      let newValue = value - minTotal
      arrowPoint = ((newValue < 0 ? (newValue)*(-1) : newValue)/(maxTotal - minTotal))
    };

    setArrowPercent(arrowPoint);
  }

  useEffect(() => {
    setStage();
    if (value !== false && value !== null && value !== undefined)
      setRangeLabelText(`${formatValue(value)} ${unit || ''}`);
    else setRangeLabelText('-');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unit, value]);

  const handleColors = () => {
    if (ranges) return ranges.map(({ category }) => GetColor(category, 'ranges'));
  };

  return (
    <>
      <s.TextPercent color={color} fontSize={labelFontSize}>
        {rangeLabelText}
      </s.TextPercent>
      <s.GaugeChartBox onClick={() => onClick && onClick()}>
        <GaugeChart
          id={name + index}
          key={graphLabel}
          className="gauge-chart"
          nrOfLevels={5}
          percent={arrowPercent || 0}
          style={{
            width: GaugeWidth || 135,
            minWidth: GaugeMinWidth || 135,
          }}
          arcsLength={arcsLength}
          colors={handleColors()}
          needleColor={rangeLabelText === '-' ? 'transparent' : color}
          needleBaseColor={rangeLabelText === '-' ? 'transparent' : color}
          arcPadding={0}
          cornerRadius={0}
          hideText
        />
      </s.GaugeChartBox>
      <s.GraphLabel>{graphLabel}</s.GraphLabel>
    </>
  );
};

const areEqual = (prev, next) => {
  return (
    prev.value === next.value &&
    prev.ranges === next.ranges &&
    prev.GaugeWidth === next.GaugeWidth
  );
};

export default React.memo(GaugeChartComponent, areEqual);
